{
  "slug": "iq-vs-eq",
  "title": "智商与EQ:有什么区别?",
  "description": "比较智商和情商(EQ ), 包括每个概念涵盖的内容、如何测量以及它们的局限性。",
  "summary": "智商关注的是某些认知能力,而情绪智能则关注感知、理解、使用和管理情绪。 两者仅部分重叠。",
  "sections": [
    {
      "heading": "IQ和EQ描述什么",
      "paragraphs": [
        "智商测试测试人们的推理能力、知识、工作记忆、视觉空间处理能力和速度,而情绪智能模型则侧重于识别情绪、理解情绪信息、调节反应和处理人际关系。",
        "简称EQ经常被用来像IQ,但情绪智能没有一个普遍接受的尺度或评分系统。"
      ]
    },
    {
      "heading": "测量的不同之处",
      "paragraphs": [
        "现有的智商测试采用标准化的表现任务和年龄规范。 情绪智能测试则采用能力任务、自我报告问卷或其他人的报告,这些方法都能捕捉到不同的东西。",
        "基于能力的情绪测试面临的问题是,在复杂的社会情况下,客观上最好的反应是什么。"
      ]
    },
    {
      "heading": "为什么两者都可能重要",
      "paragraphs": [
        "认知技能帮助人们学习、分析和解决新问题,情感和社会技能支持沟通、团队合作、冲突管理和福祉。",
        "结果取决于能力、个性、动机、知识、健康、环境和机会,而不是取决于一个人的能力、个性、动机、知识、健康、环境和机会。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "EQ比IQ更重要吗?",
      "answer": "没有普遍的赢家,不同的目标需要不同的认知、情感、实践和社交技能的组合。"
    },
    {
      "question": "EQ能否得到提高?",
      "answer": "情绪词汇、观点采取和调节策略等技能可以练习,但结果取决于背景。"
    }
  ],
  "related": ["iq-vs-intelligence", "what-is-iq", "can-iq-change-over-time"]
}
